// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n.package-state[data-v-3e30d2d9] {\n  width: 100%;\n}\n.package-state-pop .el-select-dropdown__item[data-v-3e30d2d9] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.package-state-pop .el-select-dropdown__item .state-code[data-v-3e30d2d9] {\n  margin-left: auto;\n  color: #8492a6;\n  font-size: 13px;\n}", ""]);
// Exports
module.exports = exports;
